import { Frow, IconButton40, IconNames16, Intent } from '@pinpointhq/thumbtack';
import * as React from 'react';
import { LoadingSpinner } from '..';

export interface IEditableRowProps {
  canMask?: boolean;
  isEditing: boolean;
  editEnabled?: boolean;
  saveEnabled?: boolean;
  deleteEnabled?: boolean;
  showEdit: boolean;
  showSave?: boolean;
  showDelete?: boolean;
  isMasked?: boolean;
  isSubmitting: boolean;
  children: React.ReactNode;
  editingInput: React.ReactNode;
  handleEdit: () => void;
  handleMask?: () => void;
  handleSave: () => void;
  handleCancel: () => void;
  handleDelete?: () => void;
}

export function EditableRow(props: IEditableRowProps) {
  const {
    canMask,
    isMasked,
    isEditing,
    editEnabled = true,
    saveEnabled = true,
    deleteEnabled = false,
    showSave = true,
    showEdit,
    showDelete = false,
    isSubmitting,
    children,
    editingInput,
    handleEdit,
    handleMask,
    handleSave,
    handleCancel,
    handleDelete = () => null,
  } = props;

  return (
    <Frow alignItems="center" gutters={16} flexWrap="nowrap">
      {!isEditing && (
        <>
          <div>{children}</div>
          {showEdit && (
            <div>
              {canMask && (
                <IconButton40 disabled={!editEnabled} icon={isMasked ? IconNames16.EYE_OFF : IconNames16.EYE} onClick={handleMask} aria-label="Show/Hide" />
              )}
              <IconButton40 disabled={!editEnabled} icon={IconNames16.EDIT} onClick={handleEdit} aria-label="Edit" />
            </div>
          )}
        </>
      )}

      {isEditing && (
        <>
          <div>{editingInput}</div>
          {isSubmitting && <LoadingSpinner small={true} width="40px" height="40px" />}
          {!isSubmitting && (
            <div>
              {showDelete && (
                <IconButton40
                  disabled={!deleteEnabled}
                  icon={IconNames16.DELETE}
                  onClick={handleDelete}
                  intent={Intent.DANGER}
                  aria-label="Delete"
                />
              )}
              {showSave && (
                <IconButton40
                  disabled={!saveEnabled}
                  icon={IconNames16.SAVE}
                  onClick={handleSave}
                  intent={Intent.PRIMARY}
                  aria-label="Save"
                />
              )}
              <IconButton40
                disabled={isSubmitting}
                icon={IconNames16.CLOSE}
                onClick={handleCancel}
                aria-label="Cancel"
              />
            </div>
          )}
        </>
      )}
    </Frow>
  );
}
